import { faArrowLeft, faEdit, faLock, faPlus, faTrashAlt, faUnlock } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as React from 'react';
import { toast } from 'react-toastify';
import { episodeDelete } from '../../../../../../api/actions/episode/episode-delete';
import { episodeDisable } from '../../../../../../api/actions/episode/episode-disable';
import { episodeEnable } from '../../../../../../api/actions/episode/episode-enable';
import { Button } from '../../../../../../components/shared/button/button';
import { LinkButton } from '../../../../../../components/shared/link-button/link-button';
import { Popup } from '../../../../../../components/shared/popup/popup';
import { compareText } from '../../../../../../helpers/array-helpers';
import { basePerformError } from '../../../../../../helpers/error-helpers';
import { EpisodeTypes, IEpisode } from '../../../../../../models/episode';
import { INarrative } from '../../../../../../models/narrative';
import { narrativeEnabledNotify } from '../../../../../../api/actions/narrative/narrative-enabled-notify';

import styles from '../../narrative-editor.module.scss';
import { IExternalReference } from '../../../../../../models/external-reference';

interface IProps {
    narrative: INarrative,
    history: any,
    addEpisode(): void,
    editEpisode(episodeUid: string): void,
    reloadData(): Promise<void>,
    full_episodes: boolean,
}


export function EpisodesManagement(props: IProps) {

    const [episodeForDelete, setEpisodeForDelete] = React.useState<IEpisode>();
    const [sendEnableNotificationPopupVisible, setSendEnableNotificationPopupVisible] = React.useState(false);
    const [episodes, setEpisodes] = React.useState<IEpisode[]>();
    const hasNewEpisodes = React.useMemo(() => episodes && episodes.some(e => e.isNew), [episodes]);

    React.useEffect(() => {
        if(props.narrative?.episodes) {
            if(props.full_episodes) {
                setEpisodes(props.narrative.episodes.filter(e => e.episodeType === EpisodeTypes.full_episode));
            } else {
                setEpisodes(props.narrative.episodes.filter(e => e.episodeType !== EpisodeTypes.full_episode));
            }
        }
    }, [props.narrative?.episodes, props.full_episodes]);

    const enableEpisode = async (uid: string) => {
        try {
            await episodeEnable(uid);
            await props.reloadData();
            toast.success('Item has been successfully saved');
        }
        catch(err) {
            basePerformError(err, props.history);
        }
    };

    const disableEpisode = async (uid: string) => {
        try {
            await episodeDisable(uid);
            await props.reloadData();
            toast.success('Item has been successfully saved');
        }
        catch(err) {
            basePerformError(err, props.history);
        }
    };

    const manualEpisodeEnableNotification = () => {
        setSendEnableNotificationPopupVisible(true);
    }

    const sendEpisodeEnableNotification  = async () => {
        if (!props.narrative?.uid) return;
        try {
            let episode_type = props.full_episodes ? "episodes" : "videos";
            await narrativeEnabledNotify(props.narrative.uid, true, episode_type);
            toast.success('Email notification sent');
            setSendEnableNotificationPopupVisible(false);
        } catch (err) {
            basePerformError(err, props.history);
        }    
    }
    const getServiceList = (extServices: IExternalReference[] | undefined) => {
        let serviceList = '';
        if (!extServices) return serviceList;
    
        let i = 0;
        while (i < extServices.length) {
          if (extServices[i].enabled) {
          serviceList =
            serviceList.length > 0
                ? serviceList + ', ' + extServices[i].serviceName.toUpperCase()
                : extServices[i].serviceName.toUpperCase();
          }
          i = i + 1;
        }
        return serviceList;
      };

    return (<>
        <div className="list-title">
            <div>{props.full_episodes ? 'Full Episodes' : 'Clips and Compilations'}: <strong>{ (episodes && episodes.length) || 0}</strong></div>
            { hasNewEpisodes && (
              <Button onClick={() => manualEpisodeEnableNotification()}
                      className="green">
                <span>{props.full_episodes ? 'Send Episode Activation Emails' : 'Send Video Activation Emails'}</span>
              </Button>
            )}
           
            <div>
                <Button className="orange" onClick={props.addEpisode}>
                    <FontAwesomeIcon icon={faPlus} /> <span>{props.full_episodes ? 'Add Full Episode' : 'Add Clip or Compilation'}</span>
                </Button>
            </div>
        </div>
        { episodes && !!episodes.length && (
            <table cellPadding="0" cellSpacing="0" className={`list ${styles.list}`}>
                <thead>
                    <tr>
                        <th>Episode</th>
                        <th>Services</th>
                        <th>Status</th>
                        <th>Embedable</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        episodes?.map((e: IEpisode) => (
                            <tr key={e.uid}>
                                <td>
                                    <div className={styles.markContainer}>
                                        <div className={`${styles.mark} ${e.available ? '' : styles.disabled}`}>&nbsp;</div>
                                        <div className={styles.title}>
                                            {props.full_episodes ? ('Season ' + e.season + ': Episode ' + e.numberInSeason + ': ') : ''} {e.name} {e.isNew ? <strong>[NEW]</strong> : ''}
                                        </div>
                                    </div>
                                </td>
                                <td>{getServiceList(e.externalReferences)}</td>
                                <td>{e.status?.toUpperCase()}</td>
                                <td>{e.embedable_status?.toUpperCase()}</td>
                                <td>
                                    <LinkButton onClick={() => props.editEpisode(e.uid)}>
                                        <FontAwesomeIcon icon={faEdit} /> Edit
                                    </LinkButton><br />
                                    <LinkButton
                                        className="red"
                                        onClick={() => { setEpisodeForDelete(e); }}
                                    >
                                        <FontAwesomeIcon icon={faTrashAlt} /> Delete
                                    </LinkButton><br />
                                    { !e.available && (<>
                                        <LinkButton onClick={() => enableEpisode(e.uid)}>
                                            <FontAwesomeIcon icon={faUnlock} /> Enable
                                        </LinkButton><br />
                                    </>)}
                                    { e.available && (<>
                                        <LinkButton onClick={() => disableEpisode(e.uid)}>
                                            <FontAwesomeIcon icon={faLock} /> Disable
                                        </LinkButton><br />
                                    </>)}
                                </td>
                            </tr>
                        ))
                    }
                </tbody>
            </table>
        )}



        { episodeForDelete && (
            <Popup
                modal={true}
                className="red"
                title="Delete Episode"
                onClose={() => {
                    props.reloadData();
                    setEpisodeForDelete(undefined);
                }}
                buttons={[
                    {
                        title: <><FontAwesomeIcon icon={faArrowLeft} /> <span>Cancel</span></>,
                        className: 'gray',
                        onClick: () => setEpisodeForDelete(undefined),
                    },
                    {
                        title: <><span>Delete</span> <FontAwesomeIcon icon={faTrashAlt} /></>,
                        className: 'red',
                        onClick: async () => {
                            const result = await episodeDelete(episodeForDelete.uid);
                            if(result.success) {
                                props.reloadData().catch(() => {/** */});
                                toast.success('Item has been successfully delete');
                                setEpisodeForDelete(undefined);
                            }
                        },
                    },
                ]}
            >
                Are you sure want to delete episode?<br />
                <br />
                Season: <strong>{episodeForDelete.season}</strong><br />
                Episode: <strong>{episodeForDelete.name}</strong>
            </Popup>
        )}


        { sendEnableNotificationPopupVisible && props.narrative && (
            <Popup
                title={"Send " + (props.full_episodes ? "Episode" : "Video") + " Activation Email to Users?"}
                modal={true}
                buttons={[
                    {
                        title: <><span>YES send!</span></>,
                        className: 'green',
                        onClick: () => { sendEpisodeEnableNotification(); },
                    },

                    {
                        title: <><FontAwesomeIcon icon={faArrowLeft} /> <span>Do not send</span></>,
                        className: 'gray',
                        onClick: () => { setSendEnableNotificationPopupVisible(false); },
                    },
                ]}
            >
            <div>
            { props.narrative?.fileName || props.narrative?.emailImageFileName || props.narrative?.externalImageUrl ? "Narrative image is AVAILABLE :)" : "Narrative image is NOT AVAILABLE! (Consider uploading an image before sending the email)."}
            </div>
            <div>
              { !props.narrative?.externalImageUrl && !props.narrative?.ipLicensed && ("Note: IP for this narrative is NOT licensed; consider adding an external image URL.")}
            </div>
            <div>
              { props.narrative?.externalImageUrl && !props.narrative?.ipLicensed && ("Note: IP for this narrative is NOT licensed; will use external image URL in email.")}
            </div>

            </Popup>
        )}

    </>)
}
